import { useState } from 'react';
import AppLayout from '@/components/feature/AppLayout';
import { mockEditions } from '@/mocks/editions';

export default function ExportPage() {
  const [selectedEdition, setSelectedEdition] = useState(mockEditions[1].id);
  const [format, setFormat] = useState('pdf_print');
  const [pageSize, setPageSize] = useState('A4');
  const [dpi, setDpi] = useState('300');
  const [exporting, setExporting] = useState(false);
  const [exported, setExported] = useState(false);
  const [cropMarks, setCropMarks] = useState(false);
  const [bleed, setBleed] = useState(true);

  const edition = mockEditions.find((e) => e.id === selectedEdition)!;

  const handleExport = () => {
    setExporting(true);
    setExported(false);
    setTimeout(() => { setExporting(false); setExported(true); }, 3000);
  };

  const formats = [
    { id: 'pdf_print', icon: 'ri-file-pdf-line', label: 'PDF Alta Resolução', desc: 'Para impressão profissional (CMYK)' },
    { id: 'pdf_digital', icon: 'ri-file-pdf-2-line', label: 'PDF Digital', desc: 'Otimizado para leitura online (RGB)' },
    { id: 'flipbook', icon: 'ri-book-open-line', label: 'Flipbook HTML5', desc: 'Versão interativa para web' },
    { id: 'pages_zip', icon: 'ri-folder-zip-line', label: 'Páginas Individuais', desc: 'ZIP com cada página separada' },
  ];

  const recentExports = [
    { name: 'Edição_14819_print.pdf', size: '48.2 MB', date: '06/04/2026', type: 'PDF Impressão' },
    { name: 'Edição_14818_digital.pdf', size: '12.1 MB', date: '05/04/2026', type: 'PDF Digital' },
    { name: 'Edição_14817_flipbook.zip', size: '8.4 MB', date: '04/04/2026', type: 'Flipbook' },
    { name: 'Edição_14816_pages.zip', size: '22.7 MB', date: '03/04/2026', type: 'Páginas ZIP' },
  ];

  return (
    <AppLayout>
      <div className="p-6 space-y-0">
        {/* Page Header */}
        <div className="border-b-2 border-[#111111] pb-3 mb-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#C41230] mb-1">Jardel City Post — Sistema Editorial</p>
              <h1 className="font-['Playfair_Display'] text-2xl font-bold text-[#111111]">Exportar & Distribuir</h1>
            </div>
            <div className="text-right">
              <p className="text-[10px] text-[#666666] uppercase tracking-widest">Formatos disponíveis</p>
              <p className="font-['Playfair_Display'] text-lg font-bold text-[#111111]">4 formatos</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left: Config */}
          <div className="lg:col-span-2 space-y-5">

            {/* Edition Select */}
            <div className="bg-white border border-[#E0E0E0]">
              <div className="border-b-2 border-[#111111] px-5 py-3 flex items-center justify-between">
                <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Selecionar Edição</h2>
                <span className="text-[10px] uppercase tracking-widest text-[#666666]">{mockEditions.filter(e => e.status !== 'planejado').length} disponíveis</span>
              </div>
              <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
                {mockEditions.filter((e) => e.status !== 'planejado').map((ed) => (
                  <div
                    key={ed.id}
                    onClick={() => setSelectedEdition(ed.id)}
                    className={`flex items-center gap-3 p-3 border cursor-pointer transition-all ${selectedEdition === ed.id ? 'border-[#111111] border-l-4 border-l-[#C41230] bg-[#F8F8F8]' : 'border-[#E0E0E0] hover:border-[#999999]'}`}
                  >
                    <div className="w-10 h-14 overflow-hidden flex-shrink-0 border border-[#E0E0E0]">
                      <img src={ed.coverImage} alt="" className="w-full h-full object-cover object-top" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-bold text-[#111111] uppercase tracking-wide">Edição #{ed.number}</p>
                      <p className="text-[11px] text-[#555555] truncate">{ed.theme}</p>
                      <p className="text-[10px] text-[#888888] mt-0.5">{ed.pages} págs · {ed.articles} artigos</p>
                    </div>
                    {selectedEdition === ed.id && (
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-[#C41230]"></i>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Format Select */}
            <div className="bg-white border border-[#E0E0E0]">
              <div className="border-b-2 border-[#111111] px-5 py-3 flex items-center justify-between">
                <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Formato de Exportação</h2>
                <span className="text-[10px] uppercase tracking-widest text-[#666666]">Selecione um</span>
              </div>
              <div className="p-5 grid grid-cols-2 gap-3">
                {formats.map((f) => (
                  <div
                    key={f.id}
                    onClick={() => setFormat(f.id)}
                    className={`flex items-start gap-3 p-4 border cursor-pointer transition-all ${format === f.id ? 'border-[#111111] border-l-4 border-l-[#C41230] bg-[#F8F8F8]' : 'border-[#E0E0E0] hover:border-[#999999]'}`}
                  >
                    <div className={`w-9 h-9 flex items-center justify-center flex-shrink-0 border ${format === f.id ? 'border-[#C41230] bg-[#C41230]/5' : 'border-[#E0E0E0] bg-[#F8F8F8]'}`}>
                      <i className={`${f.icon} text-base ${format === f.id ? 'text-[#C41230]' : 'text-[#666666]'}`}></i>
                    </div>
                    <div>
                      <p className={`text-xs font-bold uppercase tracking-wide ${format === f.id ? 'text-[#111111]' : 'text-[#333333]'}`}>{f.label}</p>
                      <p className="text-[11px] text-[#777777] mt-0.5">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Advanced Settings */}
            <div className="bg-white border border-[#E0E0E0]">
              <div className="border-b-2 border-[#111111] px-5 py-3">
                <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Configurações Avançadas</h2>
              </div>
              <div className="p-5">
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-2">Formato de Página</label>
                    <select
                      value={pageSize}
                      onChange={(e) => setPageSize(e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] cursor-pointer bg-white font-['Source_Serif_4']"
                    >
                      <option value="A4">A4 (210 × 297mm)</option>
                      <option value="Tabloide">Tabloide (279 × 432mm)</option>
                      <option value="Berliner">Berliner (315 × 470mm)</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-2">Resolução (DPI)</label>
                    <select
                      value={dpi}
                      onChange={(e) => setDpi(e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] cursor-pointer bg-white font-['Source_Serif_4']"
                    >
                      <option value="72">72 DPI — Web</option>
                      <option value="150">150 DPI — Digital</option>
                      <option value="300">300 DPI — Impressão</option>
                      <option value="600">600 DPI — Alta Qualidade</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <label className="flex items-center gap-3 p-3 border border-[#E0E0E0] cursor-pointer hover:border-[#999999] transition-colors">
                    <input
                      type="checkbox"
                      checked={cropMarks}
                      onChange={(e) => setCropMarks(e.target.checked)}
                      className="w-4 h-4 cursor-pointer accent-[#111111]"
                    />
                    <div>
                      <p className="text-xs font-bold text-[#111111] uppercase tracking-wide">Marcas de corte</p>
                      <p className="text-[10px] text-[#777777]">Para guilhotina industrial</p>
                    </div>
                  </label>
                  <label className="flex items-center gap-3 p-3 border border-[#E0E0E0] cursor-pointer hover:border-[#999999] transition-colors">
                    <input
                      type="checkbox"
                      checked={bleed}
                      onChange={(e) => setBleed(e.target.checked)}
                      className="w-4 h-4 cursor-pointer accent-[#111111]"
                    />
                    <div>
                      <p className="text-xs font-bold text-[#111111] uppercase tracking-wide">Sangria (3mm)</p>
                      <p className="text-[10px] text-[#777777]">Margem extra para corte</p>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            {/* Recent Exports Table */}
            <div className="bg-white border border-[#E0E0E0]">
              <div className="border-b-2 border-[#111111] px-5 py-3 flex items-center justify-between">
                <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Histórico de Exportações</h2>
                <button className="text-[10px] uppercase tracking-widest text-[#C41230] font-bold cursor-pointer hover:underline whitespace-nowrap">Ver todos</button>
              </div>
              <table className="w-full">
                <thead>
                  <tr className="border-b border-[#E0E0E0] bg-[#F8F8F8]">
                    <th className="px-5 py-2.5 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Arquivo</th>
                    <th className="px-4 py-2.5 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Tipo</th>
                    <th className="px-4 py-2.5 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Tamanho</th>
                    <th className="px-4 py-2.5 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Data</th>
                    <th className="px-4 py-2.5 text-center text-[10px] font-bold uppercase tracking-widest text-[#555555]">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {recentExports.map((f, i) => (
                    <tr key={i} className="border-b border-[#F0F0F0] hover:bg-[#FAFAFA] transition-colors">
                      <td className="px-5 py-3">
                        <div className="flex items-center gap-2">
                          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                            <i className="ri-file-pdf-line text-[#C41230] text-sm"></i>
                          </div>
                          <span className="text-xs font-medium text-[#111111] truncate max-w-[160px]">{f.name}</span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <span className="text-[10px] font-bold uppercase tracking-wide border border-[#CCCCCC] px-2 py-0.5 text-[#555555]">{f.type}</span>
                      </td>
                      <td className="px-4 py-3 text-xs text-[#555555] font-['Source_Serif_4']">{f.size}</td>
                      <td className="px-4 py-3 text-xs text-[#555555] font-['Source_Serif_4']">{f.date}</td>
                      <td className="px-4 py-3 text-center">
                        <button className="w-7 h-7 flex items-center justify-center mx-auto border border-[#E0E0E0] hover:border-[#111111] hover:bg-[#111111] hover:text-white transition-all cursor-pointer group">
                          <i className="ri-download-line text-[#555555] text-sm group-hover:text-white"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Right: Preview + Export */}
          <div className="space-y-4">
            {/* Preview */}
            <div className="bg-white border border-[#E0E0E0]">
              <div className="border-b-2 border-[#111111] px-4 py-3">
                <h3 className="font-['Playfair_Display'] text-sm font-bold text-[#111111]">Pré-visualização</h3>
              </div>
              <div className="p-4">
                <div className="aspect-[3/4] overflow-hidden border border-[#E0E0E0]">
                  <img src={edition.coverImage} alt="Capa" className="w-full h-full object-cover object-top" />
                </div>
                <div className="mt-4 space-y-0 border border-[#E0E0E0]">
                  {[
                    { label: 'Edição', value: `#${edition.number}` },
                    { label: 'Formato', value: pageSize },
                    { label: 'Resolução', value: `${dpi} DPI` },
                    { label: 'Páginas', value: String(edition.pages || 6) },
                    { label: 'Sangria', value: bleed ? 'Sim (3mm)' : 'Não' },
                    { label: 'Marcas corte', value: cropMarks ? 'Sim' : 'Não' },
                  ].map((item, idx, arr) => (
                    <div key={item.label} className={`flex justify-between px-3 py-2 ${idx < arr.length - 1 ? 'border-b border-[#F0F0F0]' : ''}`}>
                      <span className="text-[10px] uppercase tracking-widest text-[#888888] font-bold">{item.label}</span>
                      <span className="text-[11px] font-bold text-[#111111] font-['Source_Serif_4']">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Export Button */}
            <button
              onClick={handleExport}
              disabled={exporting}
              className="w-full py-3.5 bg-[#111111] text-white font-bold uppercase tracking-widest text-xs hover:bg-[#333333] transition-colors cursor-pointer disabled:opacity-60 flex items-center justify-center gap-2 whitespace-nowrap border border-[#111111]"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={exporting ? 'ri-loader-4-line animate-spin' : 'ri-download-line'}></i>
              </div>
              {exporting ? 'Gerando arquivo...' : 'Gerar e Baixar'}
            </button>

            {exported && (
              <div className="p-4 border-l-4 border-l-[#16A34A] border border-[#E0E0E0] bg-white">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-[#16A34A] text-sm"></i>
                  </div>
                  <span className="text-xs font-bold uppercase tracking-wide text-[#16A34A]">Exportação concluída</span>
                </div>
                <p className="text-[11px] text-[#555555] font-['Source_Serif_4']">Arquivo pronto para download.</p>
              </div>
            )}

            {/* Format Info */}
            <div className="bg-[#111111] p-4">
              <p className="text-[10px] font-bold uppercase tracking-widest text-[#888888] mb-3">Formato selecionado</p>
              {formats.filter(f2 => f2.id === format).map(f2 => (
                <div key={f2.id}>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${f2.icon} text-white text-sm`}></i>
                    </div>
                    <p className="text-sm font-bold text-white uppercase tracking-wide">{f2.label}</p>
                  </div>
                  <p className="text-[11px] text-[#AAAAAA] font-['Source_Serif_4']">{f2.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
